

















import { Vue, Prop, Component, Ref } from "vue-property-decorator";
import PieChart from "@/components/PieChart.vue";

@Component({ components: { PieChart } })
export default class VSidedPieChart extends Vue {
  @Prop({ default: 1 }) readonly total!: number;
  @Prop({ default: 1 }) readonly slice!: number;

  @Prop() readonly chartWidth!: number | null;
  @Prop() readonly chartHeight!: number | null;

  @Prop({ default: () => "" }) readonly title!: string;

  items = [
    { color: "#64A70B", data: [this.slice] },
    { color: "#e1e2e5", data: [this.total - this.slice] },
  ];

  private containerWidth = 0;

  mounted() {
    this.containerWidth = this.$el.clientWidth;

    addEventListener("resize", this.onResize);
  }

  destroyed() {
    removeEventListener("resize", this.onResize);
  }

  private onResize() {
    if (!this.$el) {
      return;
    }

    this.containerWidth = this.$el.clientWidth;
  }

  get width() {
    return this.chartWidth ? this.chartWidth : this.containerWidth;
  }

  get height() {
    return this.chartHeight ? this.chartHeight : this.containerWidth;
  }

  get canBeDrawn() {
    return this.width !== 0 && this.height !== 0;
  }
}
